module.exports = __webpack_public_path__ + "img/full6-min.17d4a86c.png";